/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Guest_Answers_DiscardedInputs */

const en_us2_auth_guest_answers_discarded = /** @type {(inputs: Auth_Guest_Answers_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already had a profile, so we kept yours. The answers on this device were not used.`)
};

const pt_br2_auth_guest_answers_discarded = /** @type {(inputs: Auth_Guest_Answers_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você já tinha um perfil, então mantivemos o seu. As respostas deste aparelho não foram usadas.`)
};

const es_419_auth_guest_answers_discarded = /** @type {(inputs: Auth_Guest_Answers_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya tenías un perfil, así que mantuvimos el tuyo. Las respuestas de este dispositivo no se usaron.`)
};

const pt_pt2_auth_guest_answers_discarded = /** @type {(inputs: Auth_Guest_Answers_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tinhas um perfil, por isso mantivemos o teu. As respostas deste dispositivo não foram usadas.`)
};

const fr_fr2_auth_guest_answers_discarded = /** @type {(inputs: Auth_Guest_Answers_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu avais déjà un profil, on a donc gardé le tien. Les réponses de cet appareil n'ont pas été utilisées.`)
};

const de_de2_auth_guest_answers_discarded = /** @type {(inputs: Auth_Guest_Answers_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hattest schon ein Profil, also haben wir deins behalten. Die Antworten auf diesem Gerät wurden nicht verwendet.`)
};

const it_it2_auth_guest_answers_discarded = /** @type {(inputs: Auth_Guest_Answers_DiscardedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avevi già un profilo, quindi abbiamo tenuto il tuo. Le risposte di questo dispositivo non sono state usate.`)
};

/**
* | output |
* | --- |
* | "You already had a profile, so we kept yours. The answers on this device were not used." |
*
* @param {Auth_Guest_Answers_DiscardedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_guest_answers_discarded = /** @type {((inputs?: Auth_Guest_Answers_DiscardedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Guest_Answers_DiscardedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_guest_answers_discarded(inputs)
	if (locale === "es-419") return es_419_auth_guest_answers_discarded(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_guest_answers_discarded(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_guest_answers_discarded(inputs)
	if (locale === "de-DE") return de_de2_auth_guest_answers_discarded(inputs)
	if (locale === "it-IT") return it_it2_auth_guest_answers_discarded(inputs)
	return en_us2_auth_guest_answers_discarded(inputs)
});
export { auth_guest_answers_discarded as "auth.guest_answers_discarded" }